import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Request from "./Request/Request";
import UserFormModal from "./UserFormModal";
import Management from '../Dashboard/MemberDashborad/Management';
import DeleteConfirmModal from "./DeleteConfirmModal";
import Translator from './Translator/Translator';
import History from './History/History';
import Proofreading from './Proofreading/Proofreading'
import Client from './Clients/Client'
import { useNavigate } from "react-router-dom";
import ClientCompleted from './Clients/ClientCompleted'
import HistoryDashboard from './HistoryDashboard/HistoryDashboard';
import Stamp from './Stamp/Stamp'
import Profile from './Profile/Profile'
import userAvatar from '../../assets/img/README.avif'
import PersonIcon from '@mui/icons-material/Person';
import "./Dashboard.css";
import {
  fetchClients,
  fetchMembers,
  uploadFile,
  addUser,
  deleteUser
} from "./api";
import AddIcon from "@mui/icons-material/Add";
import { FaTrash } from "react-icons/fa";
import axios from 'axios';

const Dashboard = () => {
  const navigate = useNavigate();

  const [countries, setCountries] = useState([]);
  const [state, setState] = useState({
    flag: true,
    showTranslator: false,
    shownHistory: false,
    showForm: false,
    activeView: "management",
    activeAdminView: 'home',
    activeClientView: "client",
    formType: null,
    file: null,
    clients: [],
    members: [],
    clientToDelete: null,
    errors: {},
    successMessage: '',
    errorMessage: '',

    loginType: localStorage.getItem("role"),
    formData: {
      imageId: null,
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      role: "",
      countryCode: "+962"

    }
  });

  const [data, setData] = useState([]);

  const inputStyle = {
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    background: "#F5F3F066",
    borderRadius: "8px",
    marginBottom: "8px",
  };

  const updateState = (updates) => {
    setState(prevState => ({ ...prevState, ...updates }));
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem("jwtToken");
    return { Authorization: `${token}` };
  };


  const loadData = async () => {
    try {
      if (state.loginType === "ADMIN") {
        const [clients, members] = await Promise.all([
          fetchClients(),
          fetchMembers()
        ]);
        updateState({ clients, members });
      }
    } catch (err) {
      
      navigate("/");
      console.error("Error loading data:", err);
    }
  };

  const getStatistics = async () => {
    try {
      const res = await axios.get(
        "https://api.waraq.co/waraq/api/v1/statistics/home-statistics",
        { headers: getAuthHeaders() }
      );

      console.log('home-statistics', res.data.data);
      setData(res.data.data)
    } catch (err) {
      navigate("/");
      console.error("Can't get all get Statistics request", err);
    }
  };

  const validateForm = () => {
    const { formData } = state;
    const newErrors = {};

    if (!formData.firstName) newErrors.firstName = "First Name is required";
    if (!formData.lastName) newErrors.lastName = "Last Name is required";

    if (!formData.email) newErrors.email = "Email is required";

    updateState({ errors: newErrors });
    return Object.keys(newErrors).length === 0;
  };

  const handleOpenForm = (type) => {
    updateState({
      formType: type,
      formData: {
        ...state.formData,
        role: type === "client" ? "CLIENT" : "TRANSLATOR",
      },
      showForm: true
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      let uploadedId = state.formData.imageId;
      if (state.file) {
        uploadedId = await uploadFile(state.file);
      } else {
        uploadedId = null
      }

      let fullPhoneNumber = '';
      if (state.formData?.phoneNumber && state.formData.countryCode) {
        fullPhoneNumber = `${state.formData.countryCode}${state.formData.phoneNumber}`;
      } else {
        fullPhoneNumber = null
      }

      const newUser = {
        ...state.formData,
        phoneNumber: fullPhoneNumber,
        ...(uploadedId && { imageId: uploadedId })
      };

      // console.log('newUser' , newUser);
      // const newUser = { ...state.formData, phoneNumber: fullPhoneNumber,imageId: uploadedId };

      await addUser(newUser);

      updateState({
        showForm: false,
        file: null,
        successMessage: "Created new user successfully ..."
      });

      updateState({
        showForm: false,
        errorMessage: "",
        formData: {
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
          companyName: '',
          imageId: null
        },

        errors: {}
      });


      setTimeout(() => {
        updateState({ successMessage: "" });
      }, 3000);

      await loadData();
    } catch (err) {
      console.error("Error submitting form", err.response.data.data);
      // errorMessage
      updateState({ errorMessage: err.response.data.data })

    }
  };

  const handleDelete = async () => {
    if (state.clientToDelete) {
      try {
        await deleteUser(state.clientToDelete.id);
        updateState({ clientToDelete: null });
        await loadData();
      } catch (err) {
        console.error("Error deleting user", err);
      }
    }
  };

  const handleFormDataChange = (e) => {
    updateState({
      formData: { ...state.formData, [e.target.name]: e.target.value }
    });
  };

  const handleFileChange = (e) => {
    updateState({ file: e.target.files[0] });
  };

  const renderUserList = (users, title) => (
    <div className="sidebar-card-admin">
      <h3>{title}</h3>
      {users.length === 0 ? (
        <p className="no-users-message"> no accounts available </p>
      ) : (
        <ul>
          {users.map((user) => (
            <li key={user.id} className="admin-item">
              <div className="admin-left">
                {user.imageUrl ? (
                  <img
                    className="dot-admin"
                    src={user.imageUrl}
                    alt={`${user.firstName} ${user.lastName}`}
                  />
                ) : (
                  <PersonIcon />
                )}

                <span className="admin-name">
                  {user.firstName} {user.lastName}
                </span>
              </div>
              <FaTrash
                onClick={() => updateState({ clientToDelete: user })}
                className="delete-icon"
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );


  const renderAdminHome = () => {


    return (
      <div className="dashboard-content-admin">
        <div className="main-content-admin">
          <h1 className="requests-title">Home</h1>
          <div className="months-grid-admin">
            {data.map((monthData, index) => {
              const hasTranslators = monthData.translators && monthData.translators.length > 0;
              const hasClients = monthData.clients && monthData.clients.length > 0;

              return (
                <div key={index} className="month-card-admin">
                  <h3>{monthData.month}</h3>

                  {!hasTranslators && !hasClients ? (
                    <p className="no-data-message">No data available for this month.</p>
                  ) : (
                    <>
                      {hasTranslators && (
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Role</th>
                              <th>Name</th>
                              <th>Pages Translated</th>
                              <th>Pages Proofread</th>
                            </tr>
                          </thead>
                          <tbody>
                            {monthData.translators.map((translator) => (
                              <tr key={translator.translatorId}>
                                <td>Translator</td>
                                <td>{translator.translatorName}</td>
                                <td>{translator.pagesTranslated}</td>
                                <td>{translator.pagesProofreaded}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}

                      {hasClients && (
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Role</th>
                              <th>Name</th>
                              <th>Pages Translated</th>
                            </tr>
                          </thead>
                          <tbody>
                            {monthData.clients.map((client) => (
                              <tr key={client.clientId}>
                                <td>Client</td>
                                <td>{client.clientName}</td>
                                <td>{client.pagesTranslated}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>

        </div>

        <div className="sidebar-admin">
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}>
            <button onClick={() => handleOpenForm("client")} className="new-request">
              Client <AddIcon style={{ fontSize: "18px" }} />
            </button>
            <button onClick={() => handleOpenForm("member")} className="new-request">
              Member <AddIcon style={{ fontSize: "18px" }} />
            </button>
          </div>

          {renderUserList(state.members, "Team & Role")}
          {renderUserList(state.clients, "Clients")}
        </div>
      </div>
    );
  };




  const renderClientSide = () => {
    // 
    // activeClientView:"client",

    switch (state.activeClientView) {
      case "client":
        return <Client />;

      case "clientCompleted":
        return <ClientCompleted />

      default:
        return <Profile />
    }
  }
  const renderAdminContent = () => {
    switch (state.activeAdminView) {
      case "Request":
        return <Request />;
      case "historyDashboard":
        return <HistoryDashboard />;
      case 'userProfile':
        return <Profile />
      case "Stamp":
        return <Stamp />;
      case "home":
      default:
        return state.flag ? renderAdminHome() : null;
    }
  };

  const renderTranslatorContent = () => {
    switch (state.activeView) {
      case "management":
        return <Management />;
      case "translator":
        return <Translator />;
      case "history":
        return <History />;
      case "userProfile":
        return <Profile />;
      case "Proofreading":
        return <Proofreading />;
      default:
        return <Management />;
    }
  };


  const fetchCountries = async () => {
    try {
      const { data } = await axios.get(
        "https://restcountries.com/v3.1/all?fields=name,idd,flags"
      );
      const formatted = data
        .filter(c => c.idd?.root)
        .map(c => ({
          name: c.name.common,
          code: `${c.idd.root}${c.idd.suffixes ? c.idd.suffixes[0] : ""}`,
          flag: c.flags?.png
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setCountries(formatted);
      const jordan = formatted.find(c => c.code === '+962');

    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };




  useEffect(() => {
    fetchCountries();
    getStatistics();
  }, []);

  useEffect(() => {
    loadData();
  }, [state.loginType]);


  const handleCancel = () => {
    updateState({
      showForm: false,
      errorMessage: "",
      formData: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        companyName: '',
        imageId: null
      },

      errors: {}
    });
  };

  return (
    <div className="dashboard">
      <Sidebar
        setActiveView={(view) => updateState({ activeView: view })}
        setActiveAdminView={(view) => updateState({ activeAdminView: view })}
        setActiveClientView={(view) => updateState({ activeClientView: view })}

      />

      {state.loginType === 'ADMIN' && renderAdminContent()}
      {state.loginType === "TRANSLATOR" && renderTranslatorContent()}
      {state.loginType == 'CLIENT' && renderClientSide()}

      {state.successMessage && (
        <div className="popup-message">
          {state.successMessage}
        </div>
      )}

      <UserFormModal
        showForm={state.showForm}
        formType={state.formType}
        formData={state.formData}
        errorMessage={state.errorMessage}
        errors={state.errors}
        inputStyle={inputStyle}
        onClose={handleCancel}
        onSubmit={handleSubmit}
        countries={countries}
        onChange={handleFormDataChange}
        onFileChange={handleFileChange}
      />

      <DeleteConfirmModal
        show={!!state.clientToDelete}
        onCancel={() => updateState({ clientToDelete: null })}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default Dashboard;